import React, { useState, useContext, useEffect } from "react";

import { Context } from "../context";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Header from "./Header";
import Footer from "./Footer";
import { RotatingLines } from "react-loader-spinner";
import { env as environment } from "../controllers/environment";
import ls from "localstorage-slim";

ls.config.encrypt = true;
const NotFound = () => {
	const navigate = useNavigate();
	const { data, setData, inputEmail, setButtonStatus } = useContext(Context);
	const [spinner, setSpinner] = useState(false);

	useEffect(() => {
		if (!inputEmail) navigate("/");
		// if (extraButton) scrollToBottom();
	}, []);

	const handleStartNew = async (e) => {
		e.preventDefault();
		console.log("NotFound=====", data);
		setSpinner(true);
		const json = { email: inputEmail, apikey: environment.apikey };
		await axios.post(environment.verifynew, json).then((res) => {
			// setData({ ...data, data: res?.data?.data });
			// console.log("startFresh", res.data);
			// navigate("/buttons");
			setData(res?.data);
			// setInputEmail(newEmail);
			setButtonStatus(res?.data?.data);
			ls.set("buttonstatus", JSON.stringify(res?.data?.data));
			console.log("daata::afterhandlenew::", data);

			navigate("/buttons/" + inputEmail);
		});
	};
	return (
		<div className="parent">
			{/* <Header /> */}
			<div className="main-container">
				<div className="confirmation-box">
					No previous data found with this email. Please start a <span className="font-green">new</span> verification
					<div className="confirmation-btn-container2">
						<button className="confirmation-btn" onClick={handleStartNew}>
							{spinner ? <RotatingLines strokeColor="white" strokeWidth="4" animationDuration="0.75" width="25" visible={true} /> : "Start new"}
						</button>
					</div>
				</div>
			</div>
			<Footer />
		</div>
	);
};

export default NotFound;
